export const ON_HAND_BOOKING_HISTORY_SUFFIX = "on-hand-booking-history";
export const ON_HAND_BOOKING_PREDICTIONS_SUFFIX = "on-hand-booking-predictions";
export const ON_HAND_SCENARIO_RESULTS_SUFFIX = "on-hand-scenario-results";
export const ARR_WATERFALL_PROJECTIONS_SUFFIX = "board-stats-arr-waterfall-projections";
export const REVENUE_PROJECTIONS_SUFFIX = "board-stats-revenue-projections";

export const PCLOSE_DATA_SUFFIX = "pclose-data-paginated";
export const PUPSELL_DATA_SUFFIX = "pupsell-data-paginated";
export const PRENEWAL_DATA_SUFFIX = "prenewal-data-paginated";

export const ON_HAND_QUERY_SUFFIXES = [
    ON_HAND_BOOKING_HISTORY_SUFFIX,
    ON_HAND_BOOKING_PREDICTIONS_SUFFIX,
    ON_HAND_SCENARIO_RESULTS_SUFFIX,
];

export const SCENARIO_PROJECTION_QUERY_SUFFIXES = [
    ARR_WATERFALL_PROJECTIONS_SUFFIX,
    REVENUE_PROJECTIONS_SUFFIX,
];

export const PCLOSE_QUERY_SUFFIXES = [
    PCLOSE_DATA_SUFFIX,
    PUPSELL_DATA_SUFFIX,
    PRENEWAL_DATA_SUFFIX,
];

export const getCustomerScopedQueryPrefix = (customerId, suffix) =>
    customerId ? `${customerId}_${suffix}` : suffix;

export const normalizeScenarioIds = (scenarioIds = []) => {
    if (!Array.isArray(scenarioIds) || scenarioIds.length === 0) {
        return [];
    }

    return [...new Set(scenarioIds.filter(Boolean))].sort((a, b) =>
        a.toString().localeCompare(b.toString())
    );
};

export const buildOnHandScenarioIds = (activeScenarios = [], versionsToFetch = []) =>
    normalizeScenarioIds([...(activeScenarios || []), ...(versionsToFetch || [])]);

export const buildOnHandQueryKey = (customerId, suffix, scenarioIds = []) => [
    getCustomerScopedQueryPrefix(customerId, suffix),
    normalizeScenarioIds(scenarioIds),
];

export const invalidateQuerySuffixes = async (
    queryClient,
    customerId,
    suffixes = [],
    options = {},
) => {
    if (!queryClient || !customerId || !Array.isArray(suffixes) || suffixes.length === 0) {
        return;
    }

    await Promise.allSettled(
        suffixes.map((suffix) =>
            queryClient.invalidateQueries({
                queryKey: [getCustomerScopedQueryPrefix(customerId, suffix)],
                exact: false,
                ...options,
            })
        )
    );
};

export const invalidateOnHandQueries = (queryClient, customerId) =>
    invalidateQuerySuffixes(queryClient, customerId, ON_HAND_QUERY_SUFFIXES);

export const invalidatePCloseAndOnHandQueries = (queryClient, customerId) =>
    invalidateQuerySuffixes(queryClient, customerId, [
        ...PCLOSE_QUERY_SUFFIXES,
        ...ON_HAND_QUERY_SUFFIXES,
    ]);

export const invalidateScenarioProjectionQueries = (
    queryClient,
    customerId,
    options = {},
) => invalidateQuerySuffixes(
    queryClient,
    customerId,
    SCENARIO_PROJECTION_QUERY_SUFFIXES,
    options,
);
